<template>
  <div class="side-menu-wrap">
    <modal
      @close-modal="showModal=false"
      v-if="showModal"
    >
      <add-or-edit-menu
        :menu="selectedMenu"
        @close-modal="showModal=false"
        @add-menu="setMenuItem"
        @edit-menu="editMenuItem"
      ></add-or-edit-menu>
    </modal>
    <div class="form-wrap">
      <h2>Side Menus</h2>
      <div class="add-menu">
        <button @click="unsetSelectedMenuOpenModal">Add Menu</button>
      </div>
      <div class="menus-wrap">
        <div class="each-menu-row" v-for="menu in menuItems"
          :key="menu.smi_id"
        >
          <div class="menu">
            <div class="name-wrap">Name: <strong>{{menu.smi_name}}</strong></div>
            <div class="link-wrap">Link: <strong>{{menu.smi_link}}</strong></div>
          </div>
          <div class="buttons">
            <button class="edit-button" @click="setSelectedMenuAndShowModal(menu)">Edit</button>
            <button class="delete-button" @click="setSelectedMenuAndConfirm(menu)">Delete</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import AdminMixin from '../../views/admin-pages/adminMixin'
import AddOrEditMenu from '../../components/admin/side-menus/AddOrEditMenu'
export default {
  mixins: [
    AdminMixin
  ],
  components: {
    AddOrEditMenu
  },
  data () {
    return {
      menuItems: [],
      selectedMenu: {},
      showModal: false
    }
  },
  mounted () {
    this.getMenuItems();
  },
  methods: {
    async getMenuItems () {
      this.startLoading();
      let apiObj = {
        api: api.getMenuItems,
        onError: () => this.stopLoading()
      }

      const data = await this.apiCall(apiObj);
      let tempMenuItems = data.res;

      this.menuItems = tempMenuItems;
      this.stopLoading();
    },
    async setMenuItem (params) {
      console.log(123);
      this.startLoading();
      let apiObj = {
        api: api.setMenuItem,
        params: params,
        onError: () => this.stopLoading()
      }

      if (await this.apiCall(apiObj)) {
        this.showSuccessMessage("Menu Added.");
        await this.getMenuItems();
        this.showModal = false;
      }
      this.stopLoading();
    },
    async editMenuItem (params) {
      this.startLoading();
      let apiObj = {
        api: api.editMenuItem,
        params: params,
        onError: () => this.stopLoading()
      }

      if (await this.apiCall(apiObj)) {
        this.showSuccessMessage("Menu Updated.");
        await this.getMenuItems();
        this.showModal = false;
      }
      this.stopLoading();
    },
    setSelectedMenuAndConfirm (menu) {
      this.selectedMenu = menu;
      this.confirmAction(this.deleteMenuItem, this.$t('adminSideMenus.deleteMenuQuestion'))
    },
    async deleteMenuItem () {
      let apiObj = {
        api: api.deleteMenuItem,
        params: {
          smi_id: this.selectedMenu.smi_id
        },
        onError: () => this.stopLoading()
      }
      this.startLoading();      
        if (await this.apiCall(apiObj)) {
          this.showSuccessMessage("Menu Deleted.");
          await this.getMenuItems();
        }
      this.stopLoading();
    },
    setSelectedMenuAndShowModal (menu) {
      this.selectedMenu = menu;
      this.showModal = true;
    },
    unsetSelectedMenuOpenModal () {
      this.selectedMenu = {};
      this.showModal = true;
    }
  }
}
</script>

<style scoped>
.side-menu-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1% 10% 1% 3%;
}
.form-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 45%;
  box-shadow: 0px 0px 36px -11px rgba(0, 0, 0, 0.75);
  border-radius: 20px;
  padding: 0 20px 20px 20px;
}
.menus-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.each-menu-row {
  width: 80%;
  display: flex;
  align-items: center;
  margin: 10px 0;
}
.menu {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 60%;
}
.icon-wrap {
  max-width: 50px;
}
.buttons {
  width: 40%;
  display: flex;
  justify-content: center;
}
.delete-button {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  border: none;
  padding: 4% 7%;
  font-size: 18px;
  border-radius: 100px;
  background: var(--button-color-bright-red);
  color: white;
  margin-left: 20px;
  outline: none;
}
.edit-button {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  border: none;
  padding: 4% 7%;
  font-size: 18px;
  border-radius: 100px;
  background: var(--button-color-blue);
  color: white;
  outline: none;
}
.add-menu button {
  cursor: pointer;
  white-space: nowrap;
  border: none;
  outline: none;
  padding: 10px 20px;
  border-radius: 100px;
  font-weight: 600;
  font-size: 1.2em;
  background: var(--button-color-blue);
  color: white;
  text-align: center;
  margin: 10px 0 30px 0;
}
</style>